import { createListPage, createDeletedListPage, createDetailPage } from 'pages/common'
import { api } from 'store/modules/orders'
import { actionCreators } from 'store/modules/orders'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'orders'

export const metadata = {
  icon: 'shopping-bag',
  page: PAGE,
  isSoftDelete: true,
  urls: urls.orderList
}

const OrdersListPage = createListPage({ metadata, api, actionCreators, Content })
const DeletedOrdersListPage = createDeletedListPage({ metadata, api, actionCreators, Content })
const OrdersDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { OrdersListPage, OrdersDetailPage, DeletedOrdersListPage }

